module.exports = __webpack_public_path__ + "img/win1.268cf0f1.png";